import { ResultOf, VariablesOf, graphql } from "gql.tada";

import AvailabilitySearchFragment from "../fragments/availabilitySearch";

const AllAvailabilitySearchQuery = graphql(
  `
    query AllAvailabilitySearch(
      $restaurantIds: [Int]!
      $date: String!
      $people: Int!
    ) {
      allAvailabilitySearch(
        restaurantIds: $restaurantIds
        date: $date
        people: $people
      ) {
        ...AvailabilitySearchFragment
      }
    }
  `,
  [AvailabilitySearchFragment],
);

export type QueryVariables = VariablesOf<typeof AllAvailabilitySearchQuery>;
export type QueryResult = ResultOf<typeof AllAvailabilitySearchQuery>;

export default AllAvailabilitySearchQuery;
